module.exports = __webpack_public_path__ + "static/img/14bg_8.ab2d808.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/14bg_8.png
// module id = 650
// module chunks = 1